import colors from './compiled/colors';
import font from './compiled/font';

const tokens = {
  colors,
  font,
};

export default tokens;
